import { Box, Stack, Typography } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { SelectField } from "../../Fields/SelectField";
import { WebShopIcon } from "../../WebShopIcon";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import {
  ProposalTableCheckLabelStatus,
  ProposalTableColumnFieldTypes,
} from "@/src/shared/schemas";
import { DesktopColumnItemProps } from "../lib/type";
import { useProposalTableContext } from "./ProposalTableProvider";

// TODO: improve code
export const DesktopProposalField = ({
  name,
  columnId,
  isEditing,
  fieldItem,
  editable,
}: DesktopColumnItemProps) => {
  const { getValues } = useFormContext();
  const {
    form: { control },
    onCurrencySelectChange,
  } = useProposalTableContext();
  const selectValue = useWatch({ control, name });
  const { type } = fieldItem;


  if (
    type === ProposalTableColumnFieldTypes.SelectNumber ||
    type === ProposalTableColumnFieldTypes.SelectCurrency ||
    type === ProposalTableColumnFieldTypes.SelectNumberCurrency
  ) {
    return isEditing ? (
      <SelectField
        control={control}
        name={name}
        options={fieldItem?.options ?? []}
        readOnly={editable}
        disabled={ false }
        className="[&&&_input]:py-[7.5px] [&&&_input]:pl-1.5 [&&&_input]:pr-0"
        sx={{
          "& .MuiInputBase-root": {
            height: "36px !important",
          },
        }}
        onChange={(_, value) => {
          if (type === ProposalTableColumnFieldTypes.SelectCurrency) {
            onCurrencySelectChange?.({ value });
          }
        }}
      />
    ) : (
      <Typography>
        {selectValue?.label ?? selectValue ?? "Немає інформації"}
      </Typography>
    );
  }

  if (type === ProposalTableColumnFieldTypes.CheckLabel) {
    return (
      <Stack className="gap-2 flex-center-row">
        <Box className="flex">
          <WebShopIcon
            name={
              fieldItem.status === ProposalTableCheckLabelStatus.Positive
                ? "check"
                : "close"
            }
            className={cn("h-[17px] w-[17px] fill-dark-gray", {
              "fill-blue": fieldItem.status === "positive",
            })}
          />
        </Box>
        <Typography>{fieldItem.label}</Typography>
      </Stack>
    );
  }

  return <Typography>{fieldItem.label}</Typography>;
};
